var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: { placement: "top", width: "160" },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "p",
        {
          staticStyle: {
            "font-size": "16px",
            "word-break": "break-word",
            "text-align": "initial",
            color: "#606266",
          },
        },
        [_vm._v("\n    This device(s) will be unlinked\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "right", margin: "0" } },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "text" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("\n      cancel\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { loading: _vm.unlinking, type: "primary", size: "mini" },
              on: { click: _vm.unlink },
            },
            [_vm._v("\n      confirm\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-button",
        { attrs: { slot: "reference", type: "text" }, slot: "reference" },
        [
          _c(
            "el-tooltip",
            {
              staticClass: "item",
              attrs: {
                effect: "dark",
                content: _vm.tooltip,
                placement: "top-start",
              },
            },
            [_vm._t("default")],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }